import { useQuery } from '@/hooks/useQuery'
import Head from 'next/head'
import { ReactElement } from 'react'

import { Loading } from '@/components/Loading'
import { SignUpLayout } from '@/components/layout/web'
import { WebEula } from '@/components/web-eula'
import { ContractType } from '@/gql/graphql'
import { useClientOnly } from '@/hooks/useClientOnly'
import { LatestContractsQuery } from '@/queries'

export default function TermsOfServicePage() {
  useClientOnly()

  const [{ data: latestContractsData, fetching }] = useQuery({
    query: LatestContractsQuery,
    requestPolicy: 'cache-and-network',
  })
  const contract = latestContractsData?.latestContracts.find(
    (contract) => contract.contractType === ContractType.TermOfUsage
  )

  return (
    <>
      <Head>
        <title>ロジックラボ | 利用規約</title>
      </Head>

      {contract && <WebEula contract={contract} />}

      {fetching && (
        <div className="pointer-events-none fixed inset-0 grid place-items-center">
          <Loading />
        </div>
      )}
    </>
  )
}

TermsOfServicePage.getLayout = (page: ReactElement) => (
  <SignUpLayout>{page}</SignUpLayout>
)
